import withEntity from '@/entity/components/with-entity';

import BusinessActions from './business-actions';

export default withEntity(BusinessActions);
